import { type ReactNode, createContext, useContext } from 'react';
import { usePermissions, type UserPermissions } from '../hooks/useAuth';

// Create context for permissions
const PermissionsContext = createContext<UserPermissions | null>(null);

interface PermissionsProviderProps {
  children: ReactNode;
}

// Provider component that fetches permissions once and shares them
export function PermissionsProvider({ children }: PermissionsProviderProps) {
  const permissions = usePermissions();
  
  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
}

// Hook to use permissions from context
export function useSharedPermissions(): UserPermissions {
  const context = useContext(PermissionsContext);
  
  if (context === null) {
    throw new Error('useSharedPermissions must be used within a PermissionsProvider');
  }
  
  return context;
}